<sw-sidebar-item
    class="neti-ior-email-log-sidebar-filter-item"
    icon="regular-filter"
    :title="$t('neti-incomplete-order-reminder.mail-log.list.sidebar-filter-email-log.titleSidebarFilter')"
    :badge="filterCount"
>
    <template #headline-content>
        <a
            v-if="filterCount > 0"
            @click="onResetFilters"
        >
            {{ $t('sw-sidebar-filter-panel.resetButton') }}
        </a>
    </template>

    <div class="neti-ior-email-log-sidebar-filter">
        {% block neti_ior_email_log_sidebar_filter_mailed %}
            <mt-select
                v-model="filter.mailed"
                :label="$t('neti-incomplete-order-reminder.mail-log.list.sidebar-filter-email-log.mailedLabel')"
                @update:model-value="onUpdateFilters"
                :options="mailedOptions"
            ></mt-select>
        {% endblock %}

        {% block neti_ior_log_sidebar_filter_condition %}
            <sw-multi-select
                v-model:value="filter.conditions"
                :label="$t('neti-incomplete-order-reminder.mail-log.list.sidebar-filter-email-log.conditionLabel')"
                @update:value="onUpdateFilters"
                :options="conditionOptions"
            >
            </sw-multi-select>
        {% endblock %}

        {% block neti_ior_cart_sidebar_filter_email %}
            <sw-field
                :v-if="acl.can('customer.view')"
                type="email"
                v-model:value="filter.email"
                :label="$t('neti-incomplete-order-reminder.mail-log.list.sidebar-filter-email-log.emailLabel')"
                @update:value="onUpdateFilters"
            ></sw-field>
        {% endblock %}

        {% block neti_ior_email_log_sidebar_filter_container_created %}
            <sw-container
                columns="1fr 1fr"
                gap="15px"
            >
                {% block neti_ior_email_log_sidebar_filter_created_from %}
                    <mt-datepicker
                        v-model="filter.createdAt.from"
                        :label="$t('neti-incomplete-order-reminder.mail-log.list.sidebar-filter-email-log.createdFromLabel')"
                        @update:model-value="onUpdateFilters"
                    ></mt-datepicker>
                {% endblock %}

                {% block neti_ior_email_log_sidebar_filter_created_to %}
                    <mt-datepicker
                        v-model="filter.createdAt.to"
                        :label="$t('neti-incomplete-order-reminder.mail-log.list.sidebar-filter-email-log.createdToLabel')"
                        @update:model-value="onUpdateFilters"
                    ></mt-datepicker>
                {% endblock %}
            </sw-container>
        {% endblock %}
    </div>
</sw-sidebar-item>